import { TStore } from "@omni/components/redux/store.types";
import { isEnum } from "@omni/utils/enum.utils";
import * as ReactDOM from "react-dom/client";

import { AemComponent } from "@/client/AemComponents";
import { ComponentMap } from "@/client/tools/hydrator/@types/hydrator.types";

import Entry from "./Entry";
import RenderCallback from "./RenderCallback";

const handleLazyImages = () => {
    const images = document.querySelectorAll<HTMLImageElement>(
        'img[loading="lazy"]'
    );
    images.forEach((img) => {
        if (img.dataset.src) {
            img.src = img.dataset.src;
        }
    });
};

const AEM = (store: TStore, dataPath?: string) => {
    const components = document.querySelectorAll<HTMLElement>(
        // get all data paths or hubo-react-component classes ( .hrc )
        dataPath ? `div[data-component-name='${dataPath}']` : ".hrc"
    );

    Array.from(components)
        .filter((c) => c.closest(".js-modal") === null)
        .forEach((c) => doHydration(c, store));

    handleLazyImages();
};

const AEMModal = (store: TStore, element: HTMLElement) => {
    const components = Array.from(
        element.querySelectorAll<HTMLElement>(`div[data-component-name]`)
    );

    components.forEach((c) => doHydration(c, store));

    handleLazyImages();
};

const doHydration = async (component: HTMLElement, store: TStore) => {
    const root = ReactDOM.createRoot(component);

    const componentMap = window.hydrator.getComponentMap("AEM") as ComponentMap;

    const componentName = component.dataset.componentName;

    if (!componentName) {
        console.log("AEM::MISSING DATA-COMPONENT-NAME", component);
        return;
    }

    if (!isEnum(AemComponent, componentName)) {
        console.log("AEM component does not exist - ", componentName);
        return;
    }

    let Component = componentMap[componentName];

    if (!Component) {
        console.warn(`AEM::MISSING COMPONENT - ${componentName}`);

        const { AemComponentMap } = await import("@/client/AemComponents");

        Component = AemComponentMap[componentName];
    }

    if (!Component) {
        console.log("Component nowhere to be found - ", componentName);
        return;
    }

    const renderCallback = () => {
        component.classList.contains("hide-while-loading") &&
            component.classList.remove("hide-while-loading");
    };

    root.render(
        <RenderCallback callback={renderCallback}>
            <Entry
                innerHTML={component.innerHTML}
                data={component.dataset}
                store={store}
                Component={Component}
            />
        </RenderCallback>
    );
};

export { AEM, AEMModal };
